<template>
  <b-row>
    <template v-for="(field, index) in documents">
      <b-col cols="12" md="6" :key="`document-${index}`">
        <label v-if="field.name">
          {{ field.name }}
          <span class="text-danger" v-if="field.is_required">*</span>
        </label>
        <InputUploadImage
          :id="field.id"
          :label="field.name"
          :img="field.path"
          v-model="field.path"
          ids
          validateText="กรุณาใส่ข้อมูล"
          :isValidate="$v.companyForm.documents.$each[index].path.$error"
          @setFileName="(val) => setImageName(val, index)"
        />
        <div class="f-12 color-gray mt-1 mb-2">
          ไฟล์ที่อัพโหลดต้องเป็นไฟล์นามสกุล PDF, PNG ,JPG ขนาดไม่เกิน 2.5 mb
          เท่านั้น
        </div>
      </b-col>
    </template>
  </b-row>
</template>
<script>
import InputUploadImage from "@/components/inputs/InputUploadImage.vue";

export default {
  components: {
    InputUploadImage,
  },
  props: {
    documents: {
      type: Array,
    },
    documentFields: {
      type: Array,
    },
    $v: {
      type: Object,
    },
  },
  methods: {
    async setImageName(val, index) {
      this.documents[index].document_name = val;
      await this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss" scoped>
label {
  color: #333 !important;
  font-size: 14px !important;
  font-weight: bold !important;
  width: 100%;
  position: relative;
}
</style>
